import { CallApi } from "./CallApi";

const OpenApi = () => {
  const handleClickAPICall = async () => {
    await CallApi();
  };

  return (
    <div className="App">
      <button onClick={handleClickAPICall}>GPT Call</button>
    </div>
  );
};

export default OpenApi;
